
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { Avatar, Button, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { getUserFullName, highlightText } from 'app/utils/appHelpers';
import { useEffect, useState } from 'react';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import config from '../../../config';
import UserCustomDataTableToolbar from './UserCustomDataTableToolbar';

function UserCustomDataTable({ mainData = [], column, pageTitle, setSelectedUser, setRoleDialogStatus }) {

  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [highlightQuery, setHighlightQuery] = useState('');

  useEffect(() => {
    setData(mainData);
    setData2(mainData)
  }, [mainData])


  const updateAfterTable = (item) => {
    let tmp = data;
    const index = data.findIndex(x => x.id === item.id);
    index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(data[data.length - 1].id) + 1 })
    setData([...tmp]);
    setData2([...tmp]);
  }


  const handleRequestSort = (event, property) => {

    const tempOrderBy = property;
    let tempOrder = 'desc';

    if (orderBy === property && order === 'desc') {
      tempOrder = 'asc';
    }
    const tempdata =
      tempOrder === 'desc'
        ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
        : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));


    setData(tempdata);
    setOrder(tempOrder);
    setOrderBy(tempOrderBy);

  };

  const { baseFontSize, fabStyle } = useTemplateFontSettings();

  const DataTableHead = ({ onRequestSort, customColumnData }) => {

    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };


    return (
      <TableHead>
        <TableRow>
          {customColumnData.map(column => {
            return (
              <TableCell
                size='small'
                key={column.id}
                align={column.numeric}
                padding={column.disablePadding ? 'none' : 'normal'}
              >
                <Tooltip
                  title="Sırala"
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={createSortHandler(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  };


  return (
    <Paper className="col-md-12">
      <UserCustomDataTableToolbar
        pageTitle={pageTitle}
        data2={data2}
        setData={setData}
        setHighlightQuery={setHighlightQuery}
      />

      <div className="flex-auto">
        <div className="table-responsive-material">
          <Table className="" size='small'>
            <DataTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={data.length}
              customColumnData={column}
            />
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {

                return (

                  <TableRow hover key={"trO" + n.id}>

                    <TableCell align="left" padding="normal" sx={{ fontSize: baseFontSize }}>
                      <Avatar
                        alt={n.name}
                        src={n && n.profileImageUrl
                          ? `${config.userAuthApiUrl}${n.profileImageUrl}`
                          : undefined}
                        onError={(e) => { e.target.onerror = null; e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl }}
                        sx={fabStyle}
                      />
                    </TableCell>

                    <TableCell align="left" padding="none" sx={{ fontSize: baseFontSize }}>{highlightText(getUserFullName(n), highlightQuery)}</TableCell>

                    <TableCell align="left" padding="none" >

                      <Tooltip style={{ width: 'auto' }} title="Ekle">
                        <Button
                          key="two"
                          onClick={() => {
                            setSelectedUser(n);
                            setRoleDialogStatus(true);
                          }}
                          sx={{ fontSize: baseFontSize }}
                        >
                          <ControlPointIcon color='container' fontSize='medium' />
                        </Button>
                      </Tooltip>

                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, page) => setPage(page)}
                  onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                  labelRowsPerPage={"Görüntülenecek Satır"}
                  rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                  showFirstButton
                  showLastButton
                  sx={{ fontSize: baseFontSize }}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>
    </Paper>
  )
}

export default UserCustomDataTable